// extracted by mini-css-extract-plugin
export var actionButton = "_kq-t";
export var buttonContainer = "_kq-0";
export var buttonContainer2 = "_kq-1";
export var buttonSection = "_kq-2";
export var details = "_kq-3";
export var dropdownItem = "_kq-5";
export var dropdownItemsContainer = "_kq-4";
export var fileInput = "_kq-r";
export var headerButton = "_kq-6";
export var icon = "_kq-7";
export var input = "_kq-8";
export var macroListItem = "_kq-9";
export var mainContent = "_kq-a";
export var microText = "_kq-b";
export var modal = "_kq-w";
export var optionsButton = "_kq-c";
export var paperclip = "_kq-s";
export var pillContent = "_kq-d";
export var preview = "_kq-e";
export var preview2 = "_kq-f";
export var quillEditor = "_kq-q";
export var selectedMacro = "_kq-g";
export var sidebar = "_kq-h";
export var sidebarHeader = "_kq-j";
export var sidebarList = "_kq-i";
export var sidebarListItem = "_kq-k";
export var sidebarSearch = "_kq-l";
export var snoozeDurationWrapper = "_kq-v";
export var statusPillContainer = "_kq-m";
export var tagsContainer = "_kq-n";
export var unselectedMacro = "_kq-o";
export var variable = "_kq-u";
export var wrapper = "_kq-p";